export default __webpack_public_path__ + "static/media/design-tool-product-of-week.6bae587d.svg";